import ListItem from '@mui/material/ListItem';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

export const ListLoader = () => (
  <>
    {Array.from({ length: 3 }, (_, index) => (
      <ListItem key={`loading-item-${index}`}>
        <Stack
          sx={{
            width: '100%',
          }}
        >
          <Skeleton animation="wave" width="75%" />
          <Skeleton animation="wave" width="75%" />
        </Stack>
      </ListItem>
    ))}
  </>
);
